<template>
    <modal name="save-aiff-link"
           :width="300"
           :height="150"
           :scrollable="true"
           @before-open="beforeOpen">

        <div class="close-x" >
            <svg-icon class="x-del-width" icon="x_admin-01"  @click.native="hide()"/>
        </div>
        <div class="m-content">
            <span class="m-text">Download link for aiff:</span>

            <textarea v-model="track.download_link" style="height:80px"></textarea>

            <a class="m-button" @click="saveTrack(track)">Сохранить</a>
        </div>

    </modal>
</template>

<script>

  import SvgIcon from '../layout/SvgIcon'

  export default {
    components: {
      SvgIcon
    },

    data () {
      return {
        track: Object,
      }
    },

    methods: {
      beforeOpen (event) {
        this.track = event.params.track
      },

      hide () {
        this.$modal.hide('save-aiff-link')
      },

      saveTrack (track) {

        this.$http.post('/api/tracks/podcasts/' + track.id, track)

        this.hide()
      },
    }
  }
</script>
<style>
    .close-x{
        float: right;
    }

    .m-content{
        padding-top: 15px;
        padding-left: 15px;
        /*width: 50%;*/
        /*margin: 0 auto;*/
    }
    .m-text{
        padding-bottom: 5px;
        color: #C8C8C8;
    }
    .m-button{
        padding-top: 15px;
        color: #C8C8C8;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/modals/AiffModal.vue